import { Box, Typography } from '@mui/material';
import React from 'react';
import { Dictionary } from 'lodash';
import { Filter } from './types';
import { Controller, useFormContext } from 'react-hook-form';
import { ChipComponent } from './ChipComponent';

interface Props<T extends string> {
  groupedFilters: Dictionary<Filter<T>[]>;
}

export const MainFiltersSection = <T extends string>({
  groupedFilters,
}: Props<T>) => {
  const { control } = useFormContext();
  const filters = Object.keys(groupedFilters).reduce((acc, key) => {
    acc = [...acc, ...groupedFilters[key]] as Filter<T>[];
    return acc;
  }, [] as Filter<T>[]);

  return (
    <Box
      display="flex"
      flexWrap="wrap"
      width="100%"
      alignItems="flex-start"
      gap={1.25}
    >
      {filters.map(
        ({
          field,
          type,
          options,
          label,
          disabled,
          inputPlaceholder,
          tooltipTitle,
          onChange,
        }) => (
          <Controller
            key={field}
            name={field}
            control={control}
            render={({ field: fieldData }) => {
              return (
                <ChipComponent
                  type={type}
                  label={label}
                  options={options}
                  inputPlaceholder={inputPlaceholder}
                  externalOnChange={onChange}
                  disabled={disabled}
                  tooltipTitle={tooltipTitle}
                  {...fieldData}
                />
              );
            }}
          />
        ),
      )}
    </Box>
  );
};
